package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.feature.domain.model.answer.SummaryAnswerModel
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel

@Composable
fun AnswerSummaryView(
    title: String,
    items: List<SummaryAnswerModel>,
    templateOptions: List<TemplateOptionModel>,
    removeClippedCorners: Boolean = false,
    horizontalPadding: Dp = LocalAppTheme.current.dimension.spacing.space2,
    contentVerticalPadding: Dp = LocalAppTheme.current.dimension.spacing.space1,
    contentHorizontalPadding: Dp = LocalAppTheme.current.dimension.spacing.space0,
) {
    var expand by remember { mutableStateOf(true) }

    AnswerSummaryContainer(
        horizontalPadding = horizontalPadding,
        removeClippedCorners = removeClippedCorners,
        onClick = {
            expand = !expand
        }
    ) {
        Column {
            AnswerSummaryHeader(
                verticalPadding = contentVerticalPadding,
                horizontalPadding = contentHorizontalPadding,
                expand = expand,
                title = title,
                totalItems = items.size
            )

            AnimatedVisibility(
                visible = expand
            ) {
                Column(
                    verticalArrangement = Arrangement.spacedBy(
                        space = LocalAppTheme.current.dimension.spacing.space3
                    )
                ) {
                    items.forEach { item ->
                        AnswerDetailView(
                            question = item.question.questionText,
                            answer = item.question.answer,
                            answerType = item.question.answerType,
                            templateOptions = templateOptions,
                            page = item.pageTitle
                        )
                    }
                }
            }
        }
    }
}
